export enum ResponseStatus {
  OK = 'OK',
  ERROR = 'error',
}
